var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 1.66699H5.3335C4.22893 1.66699 3.3335 2.56242 3.3335 3.66699V16.3337C3.3335 17.4382 4.22892 18.3337 5.33349 18.3337H14.6668C15.7714 18.3337 16.6668 17.4382 16.6668 16.3337V6.25033M12.0835 1.66699L16.6668 6.25033M12.0835 1.66699V4.25033C12.0835 5.3549 12.9789 6.25033 14.0835 6.25033H16.6668",
    stroke: "#82993C",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5727 9.16699C9.40341 9.16699 9.30183 9.24135 9.26797 9.38182L8.6162 11.844L8.28607 13.2817H8.26068L7.93902 11.8523L7.32111 9.39008C7.28725 9.24135 7.18567 9.16699 7.02485 9.16699H6.03448C5.9583 9.16699 5.89905 9.19178 5.86519 9.24135C5.83133 9.29919 5.82287 9.36529 5.84826 9.45618L7.35497 14.7772C7.39729 14.926 7.49886 15.0003 7.65969 15.0003H8.70931C8.87013 15.0003 8.97171 14.926 9.01403 14.7772L9.6912 12.4224L9.98747 11.2326H10.0129L10.3091 12.4224L10.9863 14.7772C11.0286 14.926 11.1302 15.0003 11.291 15.0003H12.3491C12.5099 15.0003 12.6115 14.926 12.6538 14.7772L14.1521 9.45618C14.1775 9.36529 14.169 9.29919 14.1351 9.24135C14.1013 9.19178 14.042 9.16699 13.9658 9.16699H12.9755C12.8147 9.16699 12.7131 9.24135 12.6792 9.39008L12.0613 11.8523L11.7481 13.2817H11.7143L11.3841 11.844L10.7324 9.38182C10.6985 9.24135 10.5969 9.16699 10.4276 9.16699H9.5727Z",
    fill: "#82993C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_doc.61c0205d40926846fd9784e020f11291.svg";